
(function(template){
define('vue!app/views/vue/components/packageDivComponent/packageScheduleComponent/DateTimeSelection',["Vue", "vuex", "moment", 'helpers', "vuejsDatepicker", 'vue!basicComponents/loadingIndicator'], function (
  Vue,
  vuex,
  moment,
  helpers,
  vuejsDatepicker,
  loadingIndicator
) {
  return {
    template: template,
    props: [,
      "bookedOrPreferredDate",
      "scheduling_package",
      "active_package_item",
      "isServiceBooked",'itemArr'
    ],
    components: {
      "vuejs-datepicker": vuejsDatepicker,
      'loading-indicator': loadingIndicator
    },
    data: function () {
      return {
        days: [],
        selectedCalenderDate: '',
        readyToBookPackage: false,
        calendarMonth: ''

      };
    },
    computed: _.extend(vuex.mapState(["currentlyEditingService", "status", "desktopMode", "activePackageItem", "isFetching",'selectedDateOnDateBar','detectedChanges']),{
        disableDates: function() {
            var location = helpers.getSelectedLocation();
            var bookingWindow = app.commonViewHelper.getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location,this.itemArr[0]));
            var now = moment.tz(bookingWindow.timeZone);
            var calendarStartTime = now.clone();
            if (!_.isEmpty(bookingWindow.endOffset)) {
                calendarStartTime.subtract(bookingWindow.endOffset)
            }
            if (!_.isEmpty(bookingWindow.endSet)) {
                _.each(bookingWindow.endSet, function (num, unit) {
                    calendarStartTime[unit](num)
                })
            }
            var calendarEndTime = moment('9999-12-31','YYYY-MM-DD');
            if (!_.isEmpty(bookingWindow.startOffset)) {
                calendarEndTime = now.clone()
                calendarEndTime.subtract(bookingWindow.startOffset)
            }
            if (!_.isEmpty(bookingWindow.startSet)) {
                _.each(bookingWindow.startSet, function (num, unit) {
                    calendarEndTime[unit](num)
                })
            }

            if(app.data.RestrictedFolio){
              if(app.data.datesForRestrictedFolio) {
                  var restrictedDates = app.data.datesForRestrictedFolio;
                  var folioStartDate = moment(restrictedDates[0].machine,'YYYY-MM-DD');
                  var folioEndDate = moment(restrictedDates[restrictedDates.length-1].machine,'YYYY-MM-DD');
                  var startDateToUse =  folioStartDate.isSameOrAfter(calendarStartTime) ? folioStartDate : calendarStartTime;
                  var endDateToUse = folioEndDate.isSameOrBefore(calendarEndTime) ? folioEndDate : calendarEndTime;
                  return {
                      to: startDateToUse.startOf('day').toDate(),
                      from: endDateToUse.startOf('day').toDate(),
                  }
              }else {
                return {
                  to: moment().toDate(),
                  from: moment().toDate(),
                }
              }
            }
           
        
            var dateList = (location.PMSRoomMandatory == "Y" ? (!!app.data.pmsDateList ? (app.data.pmsDateList[location.PropertyId] || []) : []) : []);
            if(dateList.length > 0){
              return {
                to: moment(dateList[0].machine, 'YYYY-MM-DD').toDate(),
                from: moment(dateList[dateList.length-1].machine, 'YYYY-MM-DD').toDate(),
              }
            }

            if(this.scheduling_package && this.activePackageItem!=0) {
                return { to:new Date(), from:new Date() };
            }
            return { to: calendarStartTime.startOf('day').toDate(), from: calendarEndTime.startOf('day').toDate() };
        },
        highlighted: function () {
         //Existing disabled dates computed logic start to set the highlighted date
          var selectedLocation = helpers.getSelectedLocation();
          var bookingWindow = app.commonViewHelper.getBookingWindow('Spa', _.extend({ Location: location.LocationId }, location,this.itemArr[0]));
          var now = moment.tz(bookingWindow.timeZone);
          var highlightStartDate = moment().toDate()
          var calendarStartTime = now.clone();

          if (!_.isEmpty(bookingWindow.endOffset)) {
              calendarStartTime.subtract(bookingWindow.endOffset)
          }

          if (!_.isEmpty(bookingWindow.endSet)) {
              _.each(bookingWindow.endSet, function (num, unit) {
                  calendarStartTime[unit](num)
              })
          }

          highlightStartDate = calendarStartTime.startOf('day').toDate()

          //Existing disabled dates logic in computed end
          var defaultDate = sessionStorage["phWid-" + app.data.WebFolioId] ? moment(JSON.parse(sessionStorage["phWid-" + app.data.WebFolioId]).PkgsDate,"YYYY,MM,DD").toDate() : highlightStartDate;
          if (this.formattedBookedOrPreferredDate()) {
            this.selectedCalenderDate = this.formattedBookedOrPreferredDate();
          } else if (app.data.RestrictedFolio && !app.data.datesForRestrictedFolio) { //if user logged in with a folio from past.
            this.selectedCalenderDate = moment(app.data.restrictedFolioStartDate, 'ddd MMM DD YYYY HH:mm:ss').toDate()
          } else if (selectedLocation.PMSRoomMandatory == "Y") {
            var dateList = !!app.data.pmsDateList ? (app.data.pmsDateList[selectedLocation.PropertyId] || []) : [];
            this.selectedCalenderDate = dateList.length > 0 ? moment(dateList[0].machine, 'YYYY-MM-DD').toDate() : defaultDate;
          } else {
            this.selectedCalenderDate = defaultDate;
          }
          return this.selectedCalenderDate
        }
    }),
    watch: {
      scheduling_package: function (value) {
        this.readyToBookPackage = false; //temp to make sure package state reset on service switch
      },
      selectedCalenderDate: function(val){
        var newDate = moment(val).format("YYYY-MM-DD");
        this.$store.commit("setselectedDateOnDateBar",newDate)
         !this.isFetching && !this.isServiceBooked?  this.selectDate(val):''   //is fetching is important because if user is not on scheduling screen and clicks pencil button, editMode function in parent class triggeres. So in that case if this selectDate also triggers on mount, it will result in multiple calls. To prevent it I have added isFetching which will prevent it from Wrunning second time.
      },
      isFetching: function(val){
        if(val) return;

        this.addA11yFunctionality();
      }
    },
    methods: _.extend(vuex.mapMutations([]), {
      addA11yFunctionality: function(){
        var vm = this;
        var selectedDateEl = $('.cell.day.selected');
        if(selectedDateEl.length == 0) {
          if($('.cell.day.disabled').length > 0){
            selectedDateEl = $('.cell.day.disabled').next();
          }else {
            selectedDateEl = $('.cell.day:not(.blank)').first();
          }
        }
        selectedDateEl.attr('tabindex',0);

        $('.prev, .next').attr('tabindex',0);
        $('.disabled, .blank').attr('tabindex',-1);

        $('.vdp-datepicker__calendar .next').first().attr('aria-label', 'Next Month')
        $('.vdp-datepicker__calendar .prev').first().attr('aria-label', 'Previous Month')

        $('.cell.day').each(function(index,el){
          $(el).off('keydown').on('keydown',function(e){
            vm.a11yKeyDown(e,{
              right: function() {
                if(index == $('.cell.day').length-1) {
                  $('.vdp-datepicker__calendar .next').first().attr('tabindex',0).focus();
                  return;
                }
                $(el).attr('tabindex',-1);
                $(el).next().attr('tabindex',0);
                $(el).next().focus();
              },
              left: function() {
                if(index == 0 || $(el).prev().hasClass('blank') || $(el).prev().hasClass('disabled')) {
                  if($('.vdp-datepicker__calendar .prev:not(.disabled)').length == 0) return;

                  $('.vdp-datepicker__calendar .prev').first().attr('tabindex',0).focus();
                  return;
                }

                $(el).attr('tabindex',-1);
                $(el).prev().attr('tabindex',0);
                $(el).prev().focus();
              },
              down: function() {
                e.preventDefault();
                if(index+7 >= $('.cell.day').length) return;
                var elToFocus = $($('.cell.day')[index+7]);
                if(elToFocus.hasClass('blank') || elToFocus.hasClass('disabled')) return;

                $(el).attr('tabindex',-1)
                elToFocus.attr('tabindex',0).focus();
              },
              up: function() {
                e.preventDefault();
                if(index-7 < 0) return;
                var elToFocus = $($('.cell.day')[index-7]);
                if(elToFocus.hasClass('blank') || elToFocus.hasClass('disabled')) return;

                $(el).attr('tabindex',-1)
                elToFocus.attr('tabindex',0).focus();
              },
              enter: function() {
                $(el).click();
              }
            })
          });
        });

        $('.prev, .next').off('keydown').on('keydown', function(e){
          var el = $(this);
          vm.a11yKeyDown(e, {
            enter: function() {
              el.click();
              setTimeout(vm.addA11yFunctionality, 100);
              el.focus();
            }
          });
        });
      },
      selectDate: function (day) {
        var newDate = moment(day).format("YYYY-MM-DD");
        if (!this.isFetching) {
          this.$emit('add-date',newDate, "")
          this.$store.commit("setErrorMessage", "")
        }
        if(this.isServiceBooked && this.detectedChanges.time) {
          this.$store.commit('setDetectedChanges',{'key':'time',value: false})} //When user clicks on a another time, app detect it as a change in edit mode. However, it is possible that user change a date.Thus, in that case we need to undo the time detection. note/staff change doesnt matter.
      },
      formattedBookedOrPreferredDate: function () {
        return this.bookedOrPreferredDate ? moment(this.bookedOrPreferredDate, this.localStrings.stepper.body.schedule.dateBarDaysFormat).toDate():''
      },
      applyDynamicRestrictions: function(day){
        var vm  = this;
        var Day = day.date;
        function addLeadingZeros(num, totalLength) {
          if(num.toString().length < totalLength) {
            return new Array(totalLength - num.toString().length + 1).join("0") + num;
          } else {
            return num;
          }
        }
        var activeMonth = moment(this.selectedCalenderDate).format("YYYY-MM");

        // get the active month from the selectedcalenderDate
        if(vm.calendarMonth){
          activeMonth = moment(vm.calendarMonth).format("YYYY-MM");
        }
        var fullDate = activeMonth + '-' + addLeadingZeros(Day, 2);
        var disableDay = false;
        // Dynamic restriction code for spaPreventBookingDateRanges
        if(app.customization.dynamicRestrictions && app.commonViewHelper.active_ttb_effects.spaPreventBookingDateRanges){
            var spaPreventBookingDateResult = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.spaPreventBookingDateRanges);
            if(spaPreventBookingDateResult.isActive && spaPreventBookingDateResult.value && spaPreventBookingDateResult.value.length){
              _.each(spaPreventBookingDateResult.value, function(timePeriod){
                if(timePeriod.startDate <= fullDate && fullDate <= timePeriod.endDate){
                    disableDay = true;
                }
              })
            }
        }
        if(disableDay){
          var divDate = '<div class="disabled">'+day.date+'</div>';
          day.isDisabled = true;
          day.isSelected = false;
          return divDate;
        } else {
          return day.date;
          } 
      },
      handleMonthChange: function(date){
        if(typeof date.month == 'string'){
            var month = new Date(date.timestamp).getMonthName();
            var year = new Date(date.timestamp).getFullYear();
            var monthYear = month + ',' + year;
            date = moment(monthYear, "MMM,YYYY")._d;
        }
        this.calendarMonth = moment(date);
      },
      moment: function () {
        return moment();
      },
    }),

  };
});
})('<div class="relative" > <!-- <div class="fetching-loader " v-show="isFetching"> <div></div> <p>Loading...</p> </div> --> <loading-indicator :showLoader="isFetching"></loading-indicator> <vuejs-datepicker :class="{\'blur-while-booking\': isFetching}" :inline="true" @selected="selectDate" :value="highlighted" :disabled-dates="disableDates" @changedMonth="handleMonthChange" :day-cell-content="applyDynamicRestrictions" ></vuejs-datepicker > </div>');
